import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';
import FileUpload from './Fields/FileUpload';
import Select from './Fields/Select';
import TextField from './Fields/TextField';
import OpmsFormGrid from './Grids/Form/OpmsFormGrid';
import OpmsFieldGroup from './OpmsFieldGroup';
import OpmsInput from './OpmsInput';
import { useBctApiPermissions } from '@ngt/online-patient-management-bctapi-permissions';
import * as Dtos from '../../api/Neon.Dtos';
import { useForm, useFormState } from 'react-final-form';

const systemPermissions = [
    Dtos.Permission.OpmsAdminister
];

const useStyles = makeStyles<Theme>(theme => ({
    subHeading: {
        padding: theme.spacing(3, 3, 1, 3)
    }
}));

const SourceDocuments = () => {
    const classes = useStyles();
    const form = useForm();
    const { values: formStateValues } = useFormState({ subscription: { values: true } });

    const [[canAdministerOpms]] = useBctApiPermissions(systemPermissions);

    const [updateFormFiles, setUpdateFormFiles] = React.useState<boolean>(false);

    const handleRedactFinish = React.useCallback(() => {
        setUpdateFormFiles(true);
    }, [setUpdateFormFiles]);

    React.useEffect(() => {
        const hasGuidFile = formStateValues?.sourceDocuments?.some((x: Dtos.SourceDocument) => !!x.guid) ?? false;

        if (updateFormFiles && hasGuidFile) {
            form.submit();
            setUpdateFormFiles(false);
        }
    }, [updateFormFiles, formStateValues]);

    const columns = React.useMemo(() => {
        return [
            {
                name: 'Name',
                header: (
                    <Typography
                        style={{ fontWeight: 'bold' }}
                    >
                        Name
                    </Typography>
                ),
                content: (
                    <OpmsInput
                        component={TextField}
                    />
                )
            },
            {
                name: 'FileTypeId',
                header: (
                    <Typography
                        style={{ fontWeight: 'bold' }}
                    >
                        Type
                    </Typography>
                ),
                content: (
                    <OpmsInput
                        component={Select}
                    />
                )
            },
            {
                name: 'Guid',
                header: (
                    <Typography
                        style={{ fontWeight: 'bold' }}
                    >
                        Upload
                    </Typography>
                ),
                content: (
                    <OpmsInput
                        component={FileUpload}
                        existsFieldName="Exists"
                        fileIdFieldName="Id"
                        imageFieldName="Image"
                        allowRedactOnFormDisable={canAdministerOpms ?? false} 
                        onRedactFinish={handleRedactFinish}
                    />
                )
            }
        ];
    }, [canAdministerOpms, handleRedactFinish]);

    return (
        <OpmsFieldGroup>
            <Typography
                variant="h2"
                color="primary"
                className={classes.subHeading}
            >
                Source Documents
            </Typography>
            <OpmsFormGrid
                name="SourceDocuments"
                columns={columns}
            />
        </OpmsFieldGroup>
    );
};

export default SourceDocuments;
